import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, intlShape, injectIntl } from '../../util/reactIntl';
import { Modal } from '..';
import { HostDeliveryForm } from '..';
import classNames from 'classnames';

import DeliveryIcon from '../CheckDeliveryModal/DeliveryIcon';
import css from './HostDeliveryModal.module.css';

const HostDeliveryModal = props => {
  const {
    className,
    rootClassName,
    id,
    intl,
    isOpen,
    onCloseModal,
    onManageDisableScrolling,
    onSubmit,

    // Check related props
    hostDeliveryInProgress,
    hostDeliveryError,
    listing,
    perKm,
  } = props;

  const classes = classNames('marketplaceModalBaseStyles', rootClassName || css.root, className);
  const closeButtonMessage = intl.formatMessage({
    id: 'HostDelivery.Later',
  });

  // Modal title, description and icon
  const modalTitle = <FormattedMessage id="HostDelivery.Title" />;
  const modalDescription = perKm 
    ? `Calculate delivery and pickup charges based on distance at $${perKm} per km/mi. You can adjust the final amount to offer discounts.`
    : `Please set a per-km delivery rate in your listing settings first.`;

  const modalIcon = <DeliveryIcon className={css.modalIcon} />;

  return (
    <Modal
      id={id}
      containerClassName={classes}
      contentClassName={css.modalContent}
      isOpen={isOpen}
      onClose={onCloseModal}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
      closeButtonMessage={closeButtonMessage}
    >
      {modalIcon}
      <p className="marketplaceModalTitleStyles">{modalTitle}</p>
      <p className="marketplaceModalParagraphStyles">{modalDescription}</p>
      <HostDeliveryForm
        formId="HostDeliveryForm"
        hostDeliveryInProgress={hostDeliveryInProgress}
        hostDeliveryError={hostDeliveryError}
        listing={listing}
        perKm={perKm}
        onSubmit={onSubmit}
      />
    </Modal>
  );
};

const { string } = PropTypes;

HostDeliveryModal.defaultProps = {
  className: null,
  rootClassName: null,
};

HostDeliveryModal.propTypes = {
  className: string,
  rootClassName: string,
  intl: intlShape.isRequired,
};

export default injectIntl(HostDeliveryModal);